export default "__VITE_ASSET__CDHQhing__"